import { Helmet } from 'react-helmet-async'
import PageLayout from '../components/layout/PageLayout.jsx'
import SectionHeading from '../components/ui/SectionHeading.jsx'
import PharmaCard from '../components/ui/PharmaCard.jsx'
import { qualityAssurance } from '../data/qualityAssurance.js'
import { motion } from 'framer-motion'

export default function QualityAssurancePage() {
  return (
    <PageLayout>
      <Helmet>
        <title>Quality Assurance | Ritik Medicare Pvt. Ltd.</title>
        <meta
          name="description"
          content="Ritik Medicare Quality Assurance: GMP standards, quality control, and regulatory compliance for pharmaceutical manufacturing."
        />
      </Helmet>

      <section className="bg-sectionBg">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:py-16">
          <SectionHeading
            eyebrow="Quality"
            title="Quality Assurance & Regulatory Compliance"
            subtitle="Built for GMP-aligned, documentation-first manufacturing excellence." 
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {qualityAssurance.map((x) => (
              <PharmaCard key={x.title} title={x.title} desc={x.desc} className="bg-white/80" />
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 items-start"
          >
            <div className="lg:col-span-7 rounded-3xl border border-slate-200 bg-white p-6">
              <div className="font-extrabold text-slate-900">GMP Standards</div>
              <p className="mt-2 text-sm sm:text-[16px] text-slate-600 leading-relaxed">
                Quality assurance practices focus on consistency across documentation, training, SOPs and in-process controls.
                Our goal is to support reliable production outcomes.
              </p>
              <ul className="mt-4 space-y-2 text-sm text-slate-700">
                {[
                  'Validated processes and controlled manufacturing practices',
                  'In-process checks and release testing guidance',
                  'Traceability across documentation and operational workflows',
                  'Audit-ready compliance documentation',
                ].map((t) => (
                  <li key={t} className="flex items-start gap-2">
                    <span className="mt-1 w-2 h-2 rounded-full bg-brand-accent" />
                    {t}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-5 rounded-3xl border border-slate-200 bg-white/70 p-6">
              <div className="font-extrabold text-slate-900">Quality Control</div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                We support robust quality control checkpoints that help ensure product integrity throughout development and manufacturing.
              </p>
              <div className="mt-4 space-y-3">
                {["In-process analytics", "Release testing support", "Method & documentation planning"].map((t) => (
                  <div key={t} className="rounded-2xl bg-sectionBg border border-slate-200 p-4">
                    <div className="font-bold text-slate-900">{t}</div>
                    <div className="text-sm text-slate-600 mt-1">Quality checkpoints designed for regulated workflows.</div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </PageLayout>
  )
}

